import DescriptionPaneEntryContent from './DescriptionPaneEntryContent';

export default DescriptionPaneEntryContent;
export { DescriptionPaneEntryContent };
